import axios from "axios";

const asaasGeneratePixPayment = async ({
  asaasCustomerId,
  value,
  description,
  payerEmail,
  payerCpf,
  payerName,
}) => {
  try {
    const { data } = await axios.post(
      `/asaas/payment/pix`,
      {
        asaasCustomerId,
        value,
        description,
        payerEmail,
        payerCpf,
        payerName,
      }
    );

    if (!data?.success) throw new Error();

    return {
      success: true,
      message: "Sucesso ao gerar pagamento",
      paymentId: data?.paymentId,
    };
  } catch (error) {
    return {
      success: false,
      message: "Erro ao gerar pagamento",
    };
  }
};

export { asaasGeneratePixPayment };
